'use strict'

/**
 * External Dependencies
 */
import 'jquery'

import './setup'
//import './scroll-smoother'


// helpers
import './helpers/breakpoints'
import './helpers/elementsToMaxSizes'
import './helpers/lottie'
import './helpers/lazy-load'
import './helpers/change-background-when-scrolled'
import './helpers/add-class-when-in-screen'
import './helpers/go-to-hash'
import './helpers/preloader'
import './helpers/header'
import './helpers/split-text-animate-when-in-screen'
import './helpers/responsive-buttons-swiper'
import './helpers/move-element-to-cursor'
import './helpers/paralax'

import './helpers/custom-form/custom-form'
import './helpers/custom-form/field-date'
import './helpers/custom-form/field-select-categorized'
import './helpers/custom-form/field-text'


// elements
import './elements/accordion-1'

// parts
import './parts/video'
import './parts/gallery'
import './parts/element-slider'
import './parts/load-more-filter'
import './parts/cookies'

// blocks
import './blocks/hero-slider'

// layouts
import './layouts/popup'
import './layouts/header'


// tests
import './tests'


// pages
import './page/home'
import './page/company-submitted'
import './page/tests-list'

// components
import './components/fitText';

